import * as React from "react";
import { Button, Stack } from "@mui/material";

export const ApproveAndRemoveAlertBox = ({ state, handleOpenAlert }) => {
  return (
    <>
      <Stack
        justifyContent="space-between"
        height="100%"
        gap="8px"
        maxHeight={"calc(100% - 24px)"}
      >
        Would you like to approve or reject the Account File Overwrite request ?
        <Stack direction="row" gap="8px" justifyContent="end">
          <Button
            sx={{ height: "40px", width: "57px" }}
            variant="text"
            color="error"
            onClick={() => {
              handleOpenAlert(
                false,
                state.isRejectDialogOpen ? "reject" : "approve"
              );
            }}
          >
            Reject
          </Button>
          <Button
            sx={{ height: "40px", width: "57px" }}
            variant="contained"
            //   onClick={() => {
            //     handleChange();
            //   }}
          >
            Approve
          </Button>
        </Stack>
      </Stack>
    </>
  );
};
